import React, { useContext } from 'react';

import WorkPanel from '@totem/components/surveyV2/work/WorkPanel';
import AffiliatedTickets from '@totem/components/ticketing/affiliatedList/AffiliatedTickets';
import IBCard from '@totem/components/ui_components/antDesignOverrides/IBCard';
import UserProfileContext from '@totem/components/userContext/UserProfileContext';

import ContentLayout from '../../ui_components/page/ContentLayout';

const WorkSummaryPage = () => {
  const { userProfile } = useContext(UserProfileContext);
  const showMyTickets = userProfile.organization.role > -1;

  return (
    <ContentLayout
      pageTitle={`${userProfile.organization.name} - Assigned Work`}
    >
      <IBCard isCovered>
        {showMyTickets && <AffiliatedTickets />}
        <WorkPanel />
      </IBCard>
    </ContentLayout>
  );
};

export default WorkSummaryPage;
